'use client';

import type { JSX } from 'react';

import { ProgressiveBlur } from '@/components/ui/progressive-blur';

/** Viewport-bottom frosted edge for the marketing landing page. */
export function LandingViewportBlur(): JSX.Element {
  return (
    <ProgressiveBlur
      edge="bottom"
      className="fixed inset-x-0 bottom-0 z-chart"
      data-testid="landing-viewport-blur"
      tint
    />
  );
}
